function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { ChromePicker } from 'react-color';
import { ColorLabel } from 'swag-client-common/components/ui/color-label';
import { cmykToHex, formatCmyk, rgbaToCmyk } from 'swag-common/utils/cmyk.util';
import classes from './color-picker.scss';
const getCurrentColor = (currentColor, formatFn) => {
  return typeof currentColor === 'object' && currentColor ? formatFn(currentColor) : currentColor;
};
export const ColorPicker = ({
  handleColorChange,
  currentColor,
  withDivider = false,
  handleRemoveColor,
  colorBlockClassName = '',
  colorPickerClassName = '',
  colorLabelClassName = '',
  colorHeadlineClassName = '',
  headline = 'Select your primary color'
}) => {
  const [isShownPicker, togglePicker] = React.useState(false);
  const onColorChange = color => {
    const cmyk = rgbaToCmyk(color.rgb);
    handleColorChange(_objectSpread({}, color, {
      cmyk
    }));
  };
  const colorValue = getCurrentColor(currentColor, cmykToHex);
  const colorName = getCurrentColor(currentColor, formatCmyk);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.colorBlock, colorBlockClassName)
  }, headline && /*#__PURE__*/React.createElement("p", {
    className: classnames(classes.text, colorHeadlineClassName)
  }, headline), currentColor ? /*#__PURE__*/React.createElement("div", {
    className: classes.colorLabelWrapper
  }, /*#__PURE__*/React.createElement(ColorLabel, {
    colorValue: colorValue,
    colorName: colorName,
    className: classnames(classes.colorLabelSelected, colorLabelClassName),
    onClick: () => togglePicker(!isShownPicker)
  }), !!handleRemoveColor && /*#__PURE__*/React.createElement("div", {
    className: classes.cross,
    onClick: handleRemoveColor
  })) : /*#__PURE__*/React.createElement(ColorLabel, {
    colorValue: "#e1e1e1",
    colorName: "select color",
    className: classnames(classes.colorLabel, colorLabelClassName),
    onClick: () => togglePicker(!isShownPicker)
  }), isShownPicker && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.blackout,
    onClick: () => togglePicker(!isShownPicker)
  }), /*#__PURE__*/React.createElement(ChromePicker, {
    color: colorValue || '#e1e1e1',
    disableAlpha: true,
    onChangeComplete: onColorChange,
    className: classnames(classes.colorPicker, colorPickerClassName)
  })), withDivider && /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }));
};